import { instruments as originalInstruments } from "../instruments.js";
/**
 * This method not only retrieve the list of instruments but also based on the user
 * request set some active experiments for all the instruments
 * @param preferences
 * @param request
 * @returns
 */
export function getInstruments(request) {
    if (!request) {
        return structuredClone(originalInstruments);
    }
    const isPolymer = request.analysis?.data?.isPolymer;
    const requestedExperiments = request.analysis?.data?.experiments
        ? new Set(Object.entries(request.analysis.data.experiments)
            .filter(([, value]) => value === true)
            .map(([key]) => key))
        : new Set();
    const instruments = structuredClone(originalInstruments);
    for (const instrumentKey in instruments) {
        const instrument = instruments[instrumentKey];
        const selectedExperiments = new Set(instrument.defaultExperiments
            .filter((exp) => {
            return (exp.isPolymer === isPolymer && requestedExperiments.has(exp.key));
        })
            .map((exp) => exp.experiment));
        for (const experiment of instrument.experiments) {
            if (selectedExperiments.has(experiment.experiment)) {
                experiment.enabled = true;
            }
            else {
                experiment.enabled = false;
            }
        }
    }
    return instruments;
}
//# sourceMappingURL=getInstruments.js.map